import { axiosInstance } from '../../config/http';

export const getStakeholderDetail = async (id: string) => {
  return axiosInstance.get(`prj/projects/${id}/stakeholders`);
};